import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { ItemPublic, ItemSlot, TableSlots } from '@tarot/contracts';
import { useInventory, useMe, useSetPreset } from '@/api/hooks';
import { useUi } from '@/app/store';
import { ItemPreview, Table } from '@/components/Table';
import { Empty, Skeleton } from '@/components/ui';
import { platform } from '@/platform';
import { Icon } from '@/components/Icon';

const TABS: [ItemSlot, string][] = [['cloth', 'Скатерти'], ['pattern', 'Узоры'], ['candles', 'Свечи'], ['light', 'Свет'], ['figure', 'Статуэтки'], ['pet', 'Питомцы']];

export function InventoryScreen() {
  const nav = useNavigate();
  const { data: me } = useMe();
  const { data: inv } = useInventory();
  const setPreset = useSetPreset();
  const toast = useUi((s) => s.showToast);
  const [tab, setTab] = useState<ItemSlot>('cloth');
  const [slots, setSlots] = useState<TableSlots>({});
  const [dirty, setDirty] = useState(false);

  useEffect(() => { if (me && !dirty) setSlots(me.tableSlots); }, [me, dirty]);

  if (!me || !inv) return <div className="screen"><Skeleton h={300} /></div>;
  const items = inv.items.filter((i) => i.slot === tab);

  const pick = (i: ItemPublic) => {
    if (!i.owned) { toast(i.rarity === 'event' ? 'Выпадает из ивентового баннера' : 'Купите в магазине или выбейте в гаче'); nav('/shop'); return; }
    platform.haptic('light');
    setSlots((s) => ({ ...s, [tab]: i.id }));
    setDirty(true);
  };
  const save = async () => {
    try { await setPreset.mutateAsync({ slots }); setDirty(false); platform.haptic('success'); toast('Стол обновлён'); }
    catch (e) { toast((e as Error).message, true); }
  };

  return (
    <div className="screen">
      <div className="topbar">
        <div className="title">Инвентарь</div>
        <div className="row">
          <button className="btn ghost sm" onClick={() => nav('/decks')}><Icon name="cards" size={16} />Колоды</button>
          <button className="btn primary sm" disabled={!dirty || setPreset.isPending} onClick={save}>Сохранить</button>
        </div>
      </div>
      <Table slots={slots} items={inv.items} compact />
      <div className="chips" style={{ margin: '12px 0' }}>
        {TABS.map(([k, t]) => <button key={k} className={`chip${tab === k ? ' active' : ''}`} onClick={() => setTab(k)}>{t}</button>)}
      </div>
      {items.some((i) => i.owned) ? (
        <div className="inv-grid">
          {items.map((i) => (
            <div key={i.id} className={`inv-item${slots[tab] === i.id ? ' selected' : ''}${i.owned ? '' : ' locked'}`} onClick={() => pick(i)}>
              <ItemPreview item={i} />
              <div className="t">{i.title}</div>
              {i.isNew && <span className="new">NEW</span>}
              {!i.owned && <span className="lock"><Icon name="lock" size={12} /></span>}
            </div>
          ))}
        </div>
      ) : (
        <Empty icon="🎒" text="Пока пусто" action={<button className="btn ghost sm" style={{ marginTop: 10 }} onClick={() => nav('/shop')}>В магазин</button>} />
      )}
      <p className="dim center" style={{ marginTop: 10 }}>Ивентовые предметы (питомцы, освещение) выпадают только из гачи</p>
    </div>
  );
}
